import React from "react";

interface LocationItemProps {
    location: string;
}

const LocationItem: React.FC<LocationItemProps> = ({ location }) => {
    const locationMapping: Record<string, string> = {
        "Colle Val d'Elsa": "colleElsa",
        "Casole d'Elsa": "casoleElsa",
        "Monteriggioni": "monteriggioni",
        "San Gimignano": "sanGimignano",
    };

    const imageFileName =
        locationMapping[location] || location.replace(/ /g, "").toLowerCase();

    const comuneCodes: Record<string, number> = {
        "Colle Valee d'Elsa": 12,
        "Casole d'Elsa": 4,
        "Monteriggioni": 16,
        "San Gimignano": 28,
    };

    const comuneCode = String(comuneCodes[location]).padStart(3, "0");

    return (
        <div className="mb-4 mb-lg-5 col-12 col-sm-10 col-lg-6">
            <div className="location-wrapper">
                <a
                    href={`/immobili?provincia=052&comune=052${comuneCode}`}
                    title={`Immobili a ${location}`}
                >
                    <div
                        className="location-item bg-holder"
                        style={{
                            backgroundImage: `url(/assets/images/searchLocation/${imageFileName}.jpg)`,
                        }}
                    >
                        <div className="location-item-info">
                            <h5 className="location-item-title">{location}</h5>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    );
};

export default LocationItem;